module.exports = __webpack_public_path__ + "static/media/volume.6f3ade27.svg";